const SetFontSize = () => {
  const storageKey = 'font-size-preference'

  const changeFontsize = document.querySelectorAll('.block.fontsize .option')

  changeFontsize.forEach(function (btn) {
    btn.addEventListener('click', function () {
      let selectedFontsize = btn.dataset.fontsize
      
      fontsize.value = selectedFontsize
      setPreference()
    })
  })

  const getFontSizePreference = () => {
    if (localStorage.getItem(storageKey))
      return localStorage.getItem(storageKey)
    else
      return'16'
  }
  
  const setPreference = () => {
    localStorage.setItem(storageKey, fontsize.value)
    reflectPreference()
  }
  
  const reflectPreference = () => {
    document.firstElementChild.style.fontSize = fontsize.value + 'px'
    
    let activeOption = document.querySelectorAll('.block.fontsize .option.active')
    
    if(activeOption){
      activeOption.forEach(function (btn) {
        btn.classList.remove('active')
      })
    }

    const setActiveOption = document.querySelectorAll('.block.fontsize [data-fontsize="' + fontsize.value + '"]')
    setActiveOption.forEach(function (btn) {
      btn.classList.add('active')
    })
  }
  
  const fontsize = {
    value: getFontSizePreference(),
  }
  
  // set early so no page flashes / CSS is made aware
  reflectPreference()
  
  window.onload = () => {
    // set on load so screen readers can see latest value on the button
    reflectPreference()
  }

}

export default SetFontSize